export const fonts = {
  fontFamily: "ClashGrotesk-Regular",
  letterSpacing: 1,
};

export const headingFonts = {
  fontFamily: "ClashGrotesk-Medium",
  letterSpacing: 1,
};

export const semiBoldFonts = {
  fontFamily: "ClashGrotesk-SemiBold",
  letterSpacing: 1,
};

export const cardOutline = {
  border: "1px solid #ddd", // Light border by default
  boxShadow: "none",
};

export const cardHover = {
  "&:hover": {
    border: "1px solid var(--primary-color)", // Color on hover
  },
};

export const noOutline = {
  "&:focus, &:active": { outline: "none" },
};

export const imagesSliderPrevIconButton = {
  position: "absolute",
  top: "50%",
  left: "10px",
  transform: "translateY(-50%)",
  backgroundColor: "var(--primary-color)",
  color: "white",
  width: "50px",
  height: "50px",
  zIndex: 10,
  "&:focus, &:active": { outline: "none" },
  "&:hover": { backgroundColor: "var(--primary-color)" },
};

export const imagesSliderNextIconButton = {
  position: "absolute",
  top: "50%",
  right: "10px",
  transform: "translateY(-50%)",
  backgroundColor: "var(--primary-color)",
  color: "white",
  width: "50px",
  height: "50px",
  zIndex: 10,
  "&:focus, &:active": { outline: "none" },
  "&:hover": { backgroundColor: "var(--primary-color)" },
};

export const selectStyles = {
  ...fonts,
  textAlign: "left", // Ensures text aligns left
  display: "flex",
  justifyContent: "flex-start",
};

export const mainButtonStyles = {
  ...headingFonts,
  padding: "8px 25px",
  backgroundColor: "var(--primary-color)",
  color: "white",
  textTransform: "uppercase",
  borderRadius: "50px",
  cursor: "pointer",
  transition: "background-color 0.3s ease-in-out",
  display: "flex",
  alignItems: "center",
  gap: "10px",
  "&:focus, &:active": { outline: "none" },
  "&:hover": { color: "white" },
};

export const primaryButtonStyles = {
  ...headingFonts,
  borderRadius: "25px",
  padding: "5px 15px",
  backgroundColor: "var(--primary-color)",
  color: "white",
  boxShadow: "none", // No shadow
  "&:focus, &:active": { outline: "none" },
};

export const secondaryButtonStyles = {
  ...headingFonts,
  borderRadius: "25px",
  padding: "5px 15px",
  backgroundColor: "var(--secondary-color)",
  color: "white",
  boxShadow: "none", // No shadow
  "&:focus, &:active": { outline: "none" },
};

export const applyFilterButtons = {
  ...fonts,
  padding: "3px 15px",
  backgroundColor: "var(--primary-color)",
  color: "white",
  textTransform: "uppercase",
  borderRadius: "50px",
  cursor: "pointer",
  transition: "background-color 0.3s ease-in-out",
  display: "flex",
  alignItems: "center",
  gap: "10px",
  "&:focus, &:active": { outline: "none" },
  "&:hover": { color: "white" },
};

export const clearFilterButtons = {
  ...fonts,
  padding: "3px 15px",
  backgroundColor: "#ff4949",
  color: "white",
  textTransform: "uppercase",
  borderRadius: "50px",
  cursor: "pointer",
  transition: "background-color 0.3s ease-in-out",
  display: "flex",
  alignItems: "center",
  gap: "10px",
  "&:focus, &:active": { outline: "none" },
  "&:hover": { backgroundColor: "#d32f2f", color: "white" },
};

export const notFoundBox = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  padding: "20px",
  borderRadius: "8px",
  backgroundColor: "rgba(0, 0, 0, 0.05)",
  fontFamily: "ClashGrotesk-Medium",
  letterSpacing: 1,
  animation: "fadeIn 0.5s ease-in-out",
  "@keyframes fadeIn": {
    "0%": { opacity: 0, transform: "scale(0.9)" },
    "100%": { opacity: 1, transform: "scale(1)" },
  },
};

export const textFieldStyles = {
  "& .MuiOutlinedInput-root": {
    ...fonts,
    "& fieldset": {
      borderColor: "rgba(0, 0, 0, 0.2)",
    },
    "&:hover fieldset": {
      borderColor: "var(--primary-color)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "var(--primary-color)",
      borderWidth: "2px",
    },
  },
  "& .MuiInputLabel-root": {
    ...fonts,
  },
  "& .MuiOutlinedInput-input": {
    ...fonts,
  },
};

export const myAdsListButtons = {
  textTransform: "none",
  color: "var(--primary-color)",
  fontFamily: "ClashGrotesk-Medium",
  letterSpacing: 1,
  textAlign: "left",
  border: "1px solid var(--primary-color)",
  "&:hover": {
    border: "1px solid var(--primary-color)",
  },
  "&:focus, &:active": { outline: "none" },
};

export const dashboardTabsStyle = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  // paddingTop: "20px",
  "&:focus, &:active": {
    outline: "none",
  },
};

export const dashboardSingleTabStyle = {
  fontFamily: "ClashGrotesk-Medium",
  letterSpacing: 1,
  alignItems: "flex-start",
  textAlign: "left",
  "&:focus, &:active": {
    ...semiBoldFonts,
    outline: "none",
  },
};

export const inboxNotificationBadge = {
  "& .MuiBadge-dot": {
    top: "4px", // Adjust position
    right: "-10px", // Adjust position
  },
};

export const whatsNew = {
  fontFamily: "ClashGrotesk-Medium",
  letterSpacing: 1,
  alignItems: "flex-start",
  textAlign: "left",
  backgroundColor: `rgba(${parseInt(
    "0x" + "ff5733".slice(1, 3),
    16
  )}, ${parseInt("0x" + "ff5733".slice(3, 5), 16)}, ${parseInt(
    "0x" + "ff5733".slice(5, 7),
    16
  )}, 0.4)`, // Set background color
  "&:focus, &:active": {
    ...semiBoldFonts,
    outline: "none",
  },
};

export const getStartedModalStyles = {
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "start",
  width: "100%",
  maxWidth: { sm: "95%", md: "65%" },
  padding: "24px",
  borderRadius: "12px",
  border: "1px solid #ddd",
  backgroundColor: "white",
  textAlign: "start",
  transition: "all 0.3s ease-in-out",
  "&:hover": { border: "1px solid var(--primary-color)" },
};

export const getStartedModalCloseIcon = {
  position: "absolute",
  top: "-15px",
  right: "-15px",
  color: "white",
  backgroundColor: "var(--primary-color)",
  "&:hover": {
    color: "white",
    backgroundColor: "var(--primary-color)",
  },
  "&:focus, &:active": { outline: "none" },
};

export const getStartedSmallButtons = {
  textTransform: "none",
  color: "var(--primary-color)",
  fontFamily: "ClashGrotesk-Medium",
  letterSpacing: 1,
  "&:hover": { textDecoration: "none" },
  "&:focus, &:active": { outline: "none" },
};

export const getStartedTexts = {
  color: "gray",
  fontFamily: "ClashGrotesk-Regular",
  letterSpacing: 1,
  display: "flex",
  alignItems: "center",
  textAlign: "left",
  gap: "4px",
};

export const inputBaseStyles = {
  flex: 1,
  borderRadius: "50px",
  fontFamily: "inherit",
  fontWeight: "Medium",
  fontSize: "1.1rem",
  padding: "8px 15px",
  color: "rgba(0, 0, 0, 0.8)",
  backgroundColor: "white",
  border: "1px solid rgba(0, 0, 0, 0.2)",
  transition: "border-color 0.3s",
  "&:hover": { borderColor: "var(--primary-color)" },
  "&:focus-within": { borderColor: "var(--primary-color)" },
  "::placeholder": { color: "rgba(0, 0, 0, 0.6)" },
  display: "flex",
  alignItems: "center",
  width: "100%",
};
